module.exports = __webpack_public_path__ + "static/media/mobile-dataVoucherImage.783f488c.png";